module.exports = __webpack_public_path__ + "static/img/table1.9966831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/table1.png
// module id = dq5q
// module chunks = 0